import { render, staticRenderFns } from "./interactive.vue?vue&type=template&id=1f8177b3&"
import script from "./interactive.vue?vue&type=script&lang=js&"
export * from "./interactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports